/* global Word console setTimeout document */

import { RemoteAction } from "../remoteActions";

export function saveDocument() {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve) => {
    try {
      let wasUnsaved = false;
      await Word.run(async (context) => {
        context.load(context.document, "saved");
        await context.sync();
        wasUnsaved = !context.document.saved;
        if (wasUnsaved) {
          // Save the document and wait for it to complete
          context.document.save("Save");
        }
      });
      await new Promise((r) => setTimeout(r, 2000));

      if (wasUnsaved) {
        console.log("Document saved - automatically checking for pending changes to finalize");
        const iframe = document.querySelector("iframe");
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage(
            {
              type: "checkAndFinalizeChanges",
            },
            "*"
          );
        }
      }

      // Only return success after everything is complete
      resolve({ saved: true });
    } catch (error) {
      console.log("Error: " + error);
      resolve({ saved: false, error: String(error) });
    }
  });
}

export const saveAction: RemoteAction = {
  name: "saveContent",
  onExecute: () => {
    return saveDocument();
  },
};
